import { 
    ADD_BUNDLE_ITEM,
    REMOVE_BUNDLE_ITEM,
    UPDATE_BUNDLE_ITEM
} from "../actions"
import { BundleDtoAttributes } from "../models/Bundle"
import { BundleItem } from "../models/BundleItem"
import { BundleStateHandler } from "./handler"

export const initialBundleState: BundleDtoAttributes = {
    bundleProducts: [],
}

type action =
    | { type: ADD_BUNDLE_ITEM; payload: BundleItem }
    | { type: REMOVE_BUNDLE_ITEM; payload: BundleItem }
    | { type: UPDATE_BUNDLE_ITEM; payload: BundleItem[] }

export function reducer(state = initialBundleState, action: action) {
    const handler = BundleStateHandler(state)
    switch (action.type) {
    case ADD_BUNDLE_ITEM:
        return handler.bundleAddItem(action.payload)
    case REMOVE_BUNDLE_ITEM:
        return handler.bundleRemoveItem(action.payload)
    case UPDATE_BUNDLE_ITEM:
        return handler.bundleUpdateItem(action.payload)
    default:
        return state
    }
}



// WEBPACK FOOTER //
// ./src/state/product/bundle/reducers/reducer.ts